import {z} from 'zod';

import {parseJSON} from 'shared/web';

const ServiceCampaignDataSchema = z.object({
  title: z.string().nullish(),
  note: z.string().nullish(),
  damageCode: z.string().nullish(),
  reasonForRejection: z.string().nullish(),
  status: z.string().nullish(),
});

export const getServiceCampaignData = (dataJson: string) => {
  const data = parseJSON(dataJson, ServiceCampaignDataSchema);
  return data;
};
